<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
          >商品管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>标签关联类型</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>选择关联分类标签详情</h1>
      <div class="content_wrap">
        <div class="check_box">
          <!-- <el-checkbox-group v-model="check1" direction="horizontal">
            <el-checkbox
              v-for="item in leavelOne"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group> -->
          <el-checkbox-group v-model="check2" direction="horizontal" :max="3">
            <el-checkbox
              v-for="item in leavellist"
              :key="item.typeid"
              :label="item.typeid"
              >{{ item.typename }}</el-checkbox
            >
          </el-checkbox-group>
          <!-- <el-checkbox-group v-model="check3" direction="horizontal">
            <el-checkbox
              v-for="item in leavelThree"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group>
          <el-checkbox-group v-model="check4" direction="horizontal">
            <el-checkbox
              v-for="item in leavelFour"
              :key="item.id"
              :label="item.id"
              >{{ item.labelname }}</el-checkbox
            >
          </el-checkbox-group> -->
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  // getKeywordLabel,
  getShopKeywordLabel,
  encryptstringview
} from "../../../api/api";
export default {
  name: "cLabel",
  data() {
    return {
      radio: "",
      isShowStyle: false,
      scrollTop: 0,

      leavellist: [],
      labelType: [],

      leavelOne: [],
      leavelTwo: [],
      leavelThree: [],
      leavelFour: [],

      check1: [],
      check2: [],
      check3: [],
      check4: [],

      id: '',
      loading: false,
      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        labels: "",
        // labels2: "",
        // labels3: "",
        // labels4: "",
      },
    };
  },
  created() {
    let { routerList, OPENID} = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id
         this.getDetail();
      } else {
        this.$router.back();
      }
    },

    async getDetail() {
      this.loading = true;
      let { id } = this;
      // 获取商品详情
      let shopDetail = await getCommidityDetail({ id });
      this.formData.id = shopDetail.id ? shopDetail.id : "";
      this.formData.labels = shopDetail.labels ? shopDetail.labels : "";

      // 获取关键字标签
      let labelList = await getShopKeywordLabel({
        labelids: shopDetail.labelid ? shopDetail.labelid : "",
      });
      this.leavellist = labelList;

      // 转换为整数数组
      let newArr = shopDetail.labels ? shopDetail.labels.split(",") : [];
      let intArray = newArr.map((value) => parseInt(value, 10));
      this.check2 = intArray;

      this.loading = false;
    },

    // 触发分类标签
    changeLabelType(e) {
      let { leavellist } = this;
      this.leavelOne = [];
      this.leavelTwo = [];
      this.leavelThree = [];
      this.leavelFour = [];

      leavellist.filter((item) => {
        if (item.levelnum == "068b731f32634ce6b92e7a3131268002") {
          e.some((ele) => {
            if (ele === item.levelnum) {
              this.leavelTwo.push(item);
            }
          });
        }
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({name: 'cManageIndex'})
    },

    query() {
      let { formData, check2 } = this;
      if (check2.length == 0) {
        this.$message.warning("请选择关键标签");
        return;
      }
      this.loading = true;
      formData.labels = check2.join(",");
      // formData.labels3 = check3.join(",");
      // formData.labels4 = check4.join(",");
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          this.loading = false;
            this.$message.success(data.message);
          // setTimeout(() => {
          //   this.loading = false;
          //   this.$router.back();
          // }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      align-items: flex-start;
      p {
        margin-bottom: 8px;
        font-size: 16px;
        color: #6e6e6e;
      }
      .check_box {
        margin-bottom: 30px;
        /deep/ .el-checkbox {
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>